/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RelatedWorkCenter } from '../../models/related-work-center';

export interface GetPileTurnerWorkCenterList$Params {
}

export function getPileTurnerWorkCenterList(http: HttpClient, rootUrl: string, params?: GetPileTurnerWorkCenterList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RelatedWorkCenter>>> {
  const rb = new RequestBuilder(rootUrl, getPileTurnerWorkCenterList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<RelatedWorkCenter>>;
    })
  );
}

getPileTurnerWorkCenterList.PATH = '/api/v1/PileTurner/GetPileTurnerWorkCenterList';
